(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealer-price-sync"]) return;
  try {
    
(() => {
  const panel = document.getElementById('dealer-unit-tiers');
  if (!panel) return;
  const status = panel.querySelector('[data-tier-status]');
  const amounts = [...panel.querySelectorAll('[data-tier-unit-price]')];
  const main = document.getElementById('main') || document.body;
  let expected = panel.dataset.variantId;
  let switching = false;
  let queued = false;
  let signature = '';
  const setText = (element, text) => { if (element.textContent !== text) element.textContent = text; };
  const clear = () => {
    signature = '';
    amounts.forEach(element => setText(element, '…'));
    setText(status, status.dataset.loading);
    panel.dataset.ready = 'false';
  };
  const update = () => {
    queued = false;
    const info = document.querySelector('.product-info');
    if (info?.querySelector('[data-dealer-native-price][data-dealer-kind="clearance"]')) {
      panel.hidden = true;
      info.querySelectorAll('.short-description').forEach(element => {
        if (/^推奨小売価格[：:]\s*[¥￥][\d,]+\s*$/.test(element.textContent.trim())) element.hidden = true;
      });
      return;
    }
    const wrapper = info?.querySelector('[data-dealer-native-price][data-dealer-kind="wheel"]');
    if (!wrapper) { panel.hidden = true; return; }
    const title = info.querySelector('.product-title');
    if (title && panel.previousElementSibling !== title) title.after(panel);
    panel.hidden = false;
    info.querySelectorAll('.short-description').forEach(element => {
      if (/^推奨小売価格[：:]\s*[¥￥][\d,]+\s*$/.test(element.textContent.trim())) element.hidden = true;
    });
    if (switching) { clear(); return; }
    const source = wrapper.querySelector('.nb2b-vt[data-nb2b-variant-id]');
    if (!source || source.dataset.nb2bProductId !== panel.dataset.productId || source.dataset.nb2bVariantId !== expected) { clear(); return; }
    const key = source.dataset.nb2bRenderedKey || '';
    if (!key.split(':').includes(expected)) { clear(); return; }
    const rows = [...source.querySelectorAll('tbody tr')];
    const labels = rows.map(row => row.querySelector('[data-nb2b-col="qty"]')?.textContent.trim().replace(/[–—]/g, '-'));
    const raw = rows.map(row => row.querySelector('[data-nb2b-col="price"]')?.textContent || '');
    if (rows.length !== 3 || labels.join('|') !== '1-4|5-9|10+' || raw.some(text => !/[¥￥]/.test(text))) { clear(); return; }
    const prices = raw.map(text => Number(text.replace(/[^0-9.]/g, '')));
    if (prices.some(price => !Number.isFinite(price) || price <= 0 || !Number.isInteger(price))) { clear(); return; }
    const next = [expected, ...prices].join(':');
    if (next === signature) return;
    amounts.forEach((element, index) => setText(element, new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(prices[index])));
    setText(status, status.dataset.ready);
    panel.dataset.ready = 'true';
    panel.dataset.currentVariant = expected;
    signature = next;
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  document.addEventListener('change', event => {
    if (event.target.matches('input[data-option-position]') && event.target.closest('.product-info')) { switching = true; clear(); }
  }, true);
  document.addEventListener('variant:change', event => {
    const picker = document.querySelector('.product-info variant-picker');
    if (!picker || picker.getAttribute('form-id') !== event.target.getAttribute?.('id')) return;
    const id = event.detail?.variant?.id;
    expected = id ? String(id) : '';
    switching = false;
    clear();
    schedule();
  });
  window.addEventListener('pageshow', () => {
    const picker = document.querySelector('.product-info variant-picker script[data-variant]');
    try { expected = String(JSON.parse(picker?.textContent || '{}').id || ''); } catch { expected = ''; }
    switching = false;
    clear();
    schedule();
  });
  new MutationObserver(schedule).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-nb2b-variant-id', 'data-nb2b-rendered-key'] });
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
